/**
 * Hover-autoplay (muted) video for product cards on the collection page.
 *
 * Uses delegated pointer events on the document so it keeps working after the
 * results list re-renders the grid during AJAX filtering / infinite scroll.
 * Cards without an uploaded video have no [data-card-hover-video] element and
 * are simply ignored. Touch devices and reduced-motion users are skipped.
 */
(function () {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const isTouch = window.matchMedia('(hover: none)');

  function videoIn(el) {
    const gallery = el && el.closest ? el.closest('.card-gallery') : null;
    if (!gallery) return null;
    const video = gallery.querySelector('[data-card-hover-video]');
    return video ? { gallery, video } : null;
  }

  function play({ gallery, video }) {
    if (isTouch.matches || prefersReducedMotion.matches) return;
    gallery.classList.add('is-playing-video');
    const result = video.play();
    if (result && typeof result.catch === 'function') result.catch(() => {});
  }

  function stop({ gallery, video }) {
    gallery.classList.remove('is-playing-video');
    video.pause();
    try {
      video.currentTime = 0;
    } catch (e) {
      /* ignore */
    }
  }

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    const match = videoIn(event.target);
    if (!match) return;
    // Ignore moves that originate from within the same gallery (not a real enter)
    if (match.gallery.contains(event.relatedTarget)) return;
    play(match);
  });

  document.addEventListener('pointerout', (event) => {
    const match = videoIn(event.target);
    if (!match) return;
    // Still inside the same gallery — not a real leave
    if (match.gallery.contains(event.relatedTarget)) return;
    stop(match);
  });
})();
